const UserPinType = {
    Application: 'application',
    Organization: 'organization',
    Project: 'project'
};
export { UserPinType };
